import { useState, useEffect } from "react";
import { Box, Toolbar, useMediaQuery, Grid, CircularProgress } from '@mui/material';
import { getUserAPI } from "api/IdentityServiceAPI";
import { setAppuserInfo, setuserprofileInfo, setLoggedIn, setAppId, setProfile } from "store/slice/HeaderSlice";


import { getListAPI as getPartyList } from 'components/party/PartyAPI';
import { getListAPI as getProductList } from 'components/product/ProductAPI';
import { getListAPI as getCompositionList } from 'components/composition/CompositionAPI';
import { getListAPI as getProductcompositionList } from 'components/productcomposition/ProductcompositionAPI';
import { getListAPI as getPoList } from 'components/po/PoAPI';
import { getListAPI as getOrderpomappingList } from 'components/orderpomapping/OrderpomappingAPI';
import { getListAPI as getPharmaorderList } from 'components/pharmaorder/PharmaorderAPI';
import { getListAPI as getPhpackagingmaterialList } from 'components/phpackagingmaterial/PhpackagingmaterialAPI';
import { getListAPI as getDesignvendorList } from 'components/designvendor/DesignvendorAPI';
import { getListAPI as getPhproductformList } from 'components/phproductform/PhproductformAPI';
import { getListAPI as getPhproductList } from 'components/phproduct/PhproductAPI';
import { getListAPI as getPhproductstatusList } from 'components/phproductstatus/PhproductstatusAPI';
import { getListAPI as getPhproductshapeList } from 'components/phproductshape/PhproductshapeAPI';
import { getListAPI as getPhdesignList } from 'components/phdesign/PhdesignAPI';
import { getListAPI as getProductassetList } from 'components/productasset/ProductassetAPI';
import { getListAPI as getRmunitList } from 'components/rmunit/RmunitAPI';
import { getListAPI as getRawmaterialList } from 'components/rawmaterial/RawmaterialAPI';
import { getListAPI as getProductrawList } from 'components/productraw/ProductrawAPI';
import { getListAPI as getRawdemandList } from 'components/rawdemand/RawdemandAPI';
import { getListAPI as getProductrawtorawdemandList } from 'components/productrawtorawdemand/ProductrawtorawdemandAPI';
import { getListAPI as getRmvendorList } from 'components/rmvendor/RmvendorAPI';
import { getListAPI as getRmvendorquotationList } from 'components/rmvendorquotation/RmvendorquotationAPI';
import { getListAPI as getCompositiontemplateList } from 'components/compositiontemplate/CompositiontemplateAPI';
import { getListAPI as getCtitemList } from 'components/ctitem/CtitemAPI';
import { getListAPI as getPackagingsizeList } from 'components/packagingsize/PackagingsizeAPI';
import { getListAPI as getPharmasetList } from 'components/pharmaset/PharmasetAPI';
import { getListAPI as getActionList } from '../api/ActionAPI';
import { getListAPI as getGstList} from 'components/gst/GstAPI';
import { getMyBusinessUsersAPI } from "api/CoreIdentityWebServices";
import { setMyBusinessUserList } from "store/slice/HeaderSlice";

import { useDispatch,useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { setActionList,setPartyList,setProductList,setCompositionList,setProductcompositionList,setPoList,
    setOrderpomappingList,setPharmaorderList,setPhpackagingmaterialList,setDesignvendorList,setPhproductformList,
    setPhproductList,setPhproductstatusList,setPhproductshapeList,setPhdesignList,setProductassetList,
    setRmunitList,setRawmaterialList,setProductrawList,setRawdemandList,setProductrawtorawdemandList,
    setRmvendorList,setRmvendorquotationList,setCompositiontemplateList,setCtitemList,
    setPackagingsizeList,setPharmasetList, setGstList } from 'store/slice/PharmaSlice';
import { setMessage,setInitialAPIload } from "store/slice/HeaderSlice";

export default function PharmaStoreLoader() {
    const navigate = useNavigate();
    const dispath = useDispatch();
    const getActionListSuccess = (list) =>{dispath(setActionList(list));}
    const {isLoggedIn, userprofileInfo} = useSelector((state)=>state.headerslice)

    
const getPartyListSuccess = (list) =>{dispath(setPartyList(list));}
const getProductListSuccess = (list) =>{dispath(setProductList(list));}
const getCompositionListSuccess = (list) =>{dispath(setCompositionList(list));}
const getProductcompositionListSuccess = (list) =>{dispath(setProductcompositionList(list));}
const getPoListSuccess = (list) =>{dispath(setPoList(list));}
const getOrderpomappingListSuccess = (list) =>{dispath(setOrderpomappingList(list));}
const getPharmaorderListSuccess = (list) =>{dispath(setPharmaorderList(list));}
const getPhpackagingmaterialListSuccess = (list) =>{dispath(setPhpackagingmaterialList(list));}
const getDesignvendorListSuccess = (list) =>{dispath(setDesignvendorList(list));dispath(setInitialAPIload(false))}
const getPhproductformListSuccess = (list) =>{dispath(setPhproductformList(list));}
const getPhproductListSuccess = (list) =>{dispath(setPhproductList(list));}
const getPhproductstatusListSuccess = (list) =>{dispath(setPhproductstatusList(list));}
const getPhproductshapeListSuccess = (list) =>{dispath(setPhproductshapeList(list));}
const getPhdesignListSuccess = (list) =>{dispath(setPhdesignList(list));}
const getProductassetListSuccess = (list) =>{dispath(setProductassetList(list));}
const getRmunitListSuccess = (list) =>{dispath(setRmunitList(list));}
const getRawmaterialListSuccess = (list) =>{dispath(setRawmaterialList(list));}
const getProductrawListSuccess = (list) =>{dispath(setProductrawList(list));}
const getRawdemandListSuccess = (list) =>{dispath(setRawdemandList(list));}
const getProductrawtorawdemandListSuccess = (list) =>{dispath(setProductrawtorawdemandList(list));}
const getRmvendorListSuccess = (list) =>{dispath(setRmvendorList(list));}
const getRmvendorquotationListSuccess = (list) =>{dispath(setRmvendorquotationList(list));}
const getCompositiontemplateListSuccess = (list) =>{dispath(setCompositiontemplateList(list));}
const getCtitemListSuccess = (list) =>{dispath(setCtitemList(list));}
const getPackagingsizeListSuccess = (list) =>{dispath(setPackagingsizeList(list));}
const getPharmasetListSuccess = (list) =>{dispath(setPharmasetList(list));}

const [localAPIinProgress, setLocalAPIinProgress] = useState(true);
    /***   Load User profile if JWT is found otherwise Redirect to Login  */
    useEffect(() => {
        console.log('LOADONG STARTED....')
        if (localStorage.getItem("JWT") !== null) {
                getUserAPI(loadUserSuccessCallBack, loadUserFailureCallBack);
        } else {
            navigate("/");
        }
    }, [])
    const loadUserSuccessCallBack = (response) => {
        if (response.userprofileInfo==undefined || response.appuserInfo==undefined){
            navigate('/');
            return;
        } 
        dispath(setMessage(response.userprofileInfo.businessname));
        dispath(setAppuserInfo(response.appuserInfo));
        dispath(setuserprofileInfo(response.userprofileInfo));
        dispath(setLoggedIn(true));
    }
    const loadUserFailureCallBack = (response) => {
        navigate("/");

    }
    /* -----------  */

    /***   On User Profile Load, fetch all BOs    */
    useEffect(() => {
        if (userprofileInfo!==null && userprofileInfo.username!==undefined)
            loadBOs();
    }, [userprofileInfo]);

    const loadBOs = ()=>{
        if (localStorage.getItem("JWT") === null) return;

        getMyBusinessUsersAPI({}, (response)=>{
            dispath(setMyBusinessUserList(response.userprofileInfoList.list));
        }, (error)=>{
            console.error('Error fetching business users:', error);
        });
        //getActionList(()=>{}, getActionListSuccess);

        getPharmaorderList(()=>{}, getPharmaorderListSuccess);
         getProductList(()=>{}, getProductListSuccess);

        getCompositionList(()=>{}, getCompositionListSuccess);
        getPhpackagingmaterialList(()=>{}, getPhpackagingmaterialListSuccess);
        getRawmaterialList(()=>{}, getRawmaterialListSuccess);
        getPhproductformList(()=>{}, getPhproductformListSuccess);
        getPhproductshapeList(()=>{}, getPhproductshapeListSuccess);
        getProductcompositionList(()=>{}, getProductcompositionListSuccess);
        getRmunitList(()=>{}, getRmunitListSuccess);
        getPackagingsizeList(()=>{}, getPackagingsizeListSuccess);
        getPharmasetList(()=>{}, getPharmasetListSuccess);
        getPartyList(()=>{}, getPartyListSuccess);

        //getCompositiontemplateList(()=>{}, getCompositiontemplateListSuccess);
	    getCtitemList(()=>{}, getCtitemListSuccess);
        getRmvendorList(()=>{}, getRmvendorListSuccess);
        getDesignvendorList(()=>{}, getDesignvendorListSuccess);
        
        getGstList(()=>{}, (list)=>{dispath(setGstList(list));});


        

      /*  
      
	getPartyList(()=>{}, getPartyListSuccess);
	
	getCompositionList(()=>{}, getCompositionListSuccess);
	getProductcompositionList(()=>{}, getProductcompositionListSuccess);
	getPoList(()=>{}, getPoListSuccess);
	getOrderpomappingList(()=>{}, getOrderpomappingListSuccess);
	getPharmaorderList(()=>{}, getPharmaorderListSuccess);
	getPhpackagingmaterialList(()=>{}, getPhpackagingmaterialListSuccess);
	getDesignvendorList(()=>{}, getDesignvendorListSuccess);
	getPhproductformList(()=>{}, getPhproductformListSuccess);
	getPhproductList(()=>{}, getPhproductListSuccess);
	getPhproductstatusList(()=>{}, getPhproductstatusListSuccess);
	getPhproductshapeList(()=>{}, getPhproductshapeListSuccess);
	getPhdesignList(()=>{}, getPhdesignListSuccess);
	getProductassetList(()=>{}, getProductassetListSuccess);
	getRmunitList(()=>{}, getRmunitListSuccess);
	getRawmaterialList(()=>{}, getRawmaterialListSuccess);
	getProductrawList(()=>{}, getProductrawListSuccess);
	getRawdemandList(()=>{}, getRawdemandListSuccess);
	getProductrawtorawdemandList(()=>{}, getProductrawtorawdemandListSuccess);
	
	getRmvendorquotationList(()=>{}, getRmvendorquotationListSuccess);
	getCompositiontemplateList(()=>{}, getCompositiontemplateListSuccess);
	getCtitemList(()=>{}, getCtitemListSuccess);
	getPackagingsizeList(()=>{}, getPackagingsizeListSuccess);
	getPharmasetList(()=>{}, getPharmasetListSuccess);
    */
    }
    
}